import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';

import { moderateScale, isWeb, navigateTo } from '@helpers';
import ColorsWrapper from '@styles/colors';
import BackButton from '@components/common/backButton';
import { font } from '@styles/fonts';

import Svg from '@styles/icons/svg';

const LogoComponent = ({ title = false, withText = true, small = false, isBack, marginTop = 0, maxWidth, offset, C, company, email, env }) => {
  const titleOffset = withText ? (small ? 37 : 30) : 20;

  return [
    isBack && (
      <View key={'backButton'} style={{ width: 100, height: 100, position: 'absolute', top: isWeb ? 10 : -6, left: 0 }}>
        <BackButton {...{ color: 'Button/Light/PrimaryMono' }} />
      </View>
    ),
    <View style={{ width: '100%', alignItems: 'center' }} key={'logoContent'}>
      {withText ? (
        <Svg
          icon="smartFactory"
          width={moderateScale(140)}
          height={moderateScale(69)}
          style={{ marginTop: isWeb ? 0 : moderateScale(marginTop) }}
          key="logo"
          color={'Other/Light/Logo/Factory'}
        />
      ) : (
        <Svg
          icon="smartIcon"
          width={moderateScale(27)}
          height={moderateScale(35)}
          style={{ marginTop: isWeb ? 0 : moderateScale(marginTop) }}
          key="logo"
          color={'Other/Light/Logo/Factory'}
        />
      )}
      {env && (
        <View style={{ width: '100%', justifyContent: 'center', marginTop: moderateScale(4) }}>
          <Text style={[font['Button 3'], { color: C('Button/Light/Login'), textAlign: 'center' }]}>{env}</Text>
        </View>
      )}
      {company && (
        <TouchableOpacity activeOpacity={1} onPress={() => navigateTo('ConnectorLinked')} hitSlop={{ top: 15, bottom: 15, left: 15, right: 15 }}>
          <View style={{ width: '100%', justifyContent: 'center', marginTop: moderateScale(4) }}>
            <Text style={[font['Small'], { color: C('Button/Light/Login'), textAlign: 'center' }]}>{company}</Text>
          </View>
        </TouchableOpacity>
      )}
      {email && (
        <View style={{ width: '100%', justifyContent: 'center', marginTop: moderateScale(19) }}>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary'), textAlign: 'center' }]}>{email}</Text>
        </View>
      )}
      <View
        style={[
          styles.logoWrapper,
          { marginTop: moderateScale(offset ? offset : titleOffset) },
          maxWidth ? { maxWidth: moderateScale(maxWidth) } : {},
        ]}
        key="title"
      >
        {title && (
          <View style={styles.titleBlock}>
            <Text
              style={[
                styles.titleText,
                {
                  color: C('Label/Light/Primary'),
                },
                font['Title 2'],
              ]}
            >
              {title}
            </Text>
          </View>
        )}
      </View>
    </View>,
  ];
};

export default ColorsWrapper(LogoComponent);

const styles = StyleSheet.create({
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
    marginBottom: moderateScale(20),
  },
  titleText: {
    fontWeight: 'bold',
    textAlign: 'center',
    letterSpacing: moderateScale(0.02),
  },
});
